import React, { useState } from "react";

import { ThemeProvider } from 'styled-components';
import { theme } from '@cdk-rds/core';

import { IconError, IconCheckCircle, IconStatusWarningExclamation, IconInfo } from '@cdk-rds/icons';
import { Dialog } from '@cdk-rds/dialog';
import { Button } from '@cdk-rds/button';

import './SystemMessage.css';

const MESSAGE_TYPE = {
    NEGATIVE: 'NEGATIVE',
    POSITIVE: 'POSITIVE',
    INFORM: 'INFORM',
    WARNING: 'WARNING',
}

const SystemMessage = props => {

    const [doNotShowAgain, setDoNotShowAgain] = useState(undefined);

    const onChangeDoNotShowAgain = (event) => {
        setDoNotShowAgain(event.target.checked);
    }

    const onClickOk = async () => {
        props.onOk(doNotShowAgain)
    }

    const getTitleComponent = () => {

        let titleComponent = null;

        switch (props.type) {
            case MESSAGE_TYPE.NEGATIVE:
                titleComponent = (
                    <div className={'negative-title'}>
                        <IconError height={44} width={44} />
                        <h3>{props.title}</h3>
                    </div>
                );
                break;
            case MESSAGE_TYPE.POSITIVE:
                titleComponent =  (
                    <div className={'positive-title'}>
                        <IconCheckCircle height={44} width={44} />
                        <h3>{props.title}</h3>
                    </div>
                );
                break;
            case MESSAGE_TYPE.WARNING:
                titleComponent = (
                    <div className={'warning-title'}>
                        <IconStatusWarningExclamation height={44} width={44} />
                        <h3>{props.title}</h3>
                    </div>
                );
                break;
            default:
                titleComponent = (
                    <div className={'inform-title'}>
                        <IconInfo height={44} width={44} />
                        <h3>{props.title}</h3>
                    </div>
                );
        }

        return titleComponent;

    }

    const getMessageComponent = () => {

        let messageComponent = null;
        let messageInnerComponent = (<span className={'text'}>&nbsp;{props.message}</span>);

        if(props.contentType &&
            props.contentType.toUpperCase() === 'HTML') {
            messageInnerComponent = (<span className={'text'} dangerouslySetInnerHTML={{__html: props.message}} />);
        }

        switch (props.type) {
            case MESSAGE_TYPE.NEGATIVE:
                messageComponent = (
                    <div className={'negative-message'}>
                        <span className={'attention'}>Attention!</span>
                        {messageInnerComponent}
                    </div>
                );
                break;
            case MESSAGE_TYPE.POSITIVE:
                messageComponent = (
                    <div className={'positive-message'}>
                        {messageInnerComponent}
                    </div>
                );
                break;
            case MESSAGE_TYPE.WARNING:
                messageComponent = (
                    <div className={'warning-message'}>
                        <span className={'attention'}>Attention!</span>
                        {messageInnerComponent}
                    </div>
                );
                break;
            default: {
                messageComponent = (
                    <div className={'inform-message'}>
                        {messageInnerComponent}
                    </div>
                );
            }
        }

        return messageComponent;

    }

    return (
        <ThemeProvider theme={theme}>
            <Dialog isOpen={props.isOpen}
                    title={''}
                    hideHeader={true}
                    id={'onepay-message'}
                    style={{zIndex: '10000'}}>
                    <div className={'title'}>
                        {getTitleComponent()}
                    </div>
                    <div className={'message'}>
                        {getMessageComponent()}
                    </div>
                    <div className={'footer'}>
                        <div className={'doNotShow'}>
                            <label htmlFor="vehicle2">Do not show this message again.</label>&nbsp;
                            <input type="checkbox" name="doNotShowMessageAgain" value="true" onClick={onChangeDoNotShowAgain} />
                        </div>
                        <div className={'okButton'}>
                            <Button
                                text={'OK'}
                                style={{ margin: '10px 10px 0 10px' }}
                                onClick={onClickOk}>
                            </Button>
                        </div>
                    </div>
            </Dialog>
        </ThemeProvider>
    );

}

export default SystemMessage;